import React, { useState, useEffect, useRef, useCallback, useMemo, createRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog, faDesktop, faPlusCircle, faList, faBriefcase, faUserTimes, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import Link from './actions/Link';
import Dropdown from './actions/Dropdown';
import ModalDelete from './actions/ModalDelete';

library.add(faCog, faDesktop, faPlusCircle, faList, faBriefcase, faUserTimes, faPlusCircle, faUserSlash);

export default ({ student, action, domain }) => {
    return (
        <div>
            <FontAwesomeIcon icon={['fas', action.icon]} />{' '}
            {
                {
                    link: <Link action={action} domain={domain} student={student} />,
                    dropdown: <Dropdown action={action} domain={domain} student={student} />,
                    modalDelete: <ModalDelete action={action} domain={domain} student={student} />,
                }[action.type]
            }
        </div>
    );
};
